import { getType } from 'typesafe-actions';
import { produce } from 'immer';

import { ActionsOf } from '../../../helpers/actions';
import * as companiesActions from './actions';

import { Company, CompaniesData } from 'src/components/modules/companies/types';
import { ApiError } from 'src/api/types';

const initialState: CompaniesData = {
  items: [],
  saving: false,
  loading: false,
  pageNumber: 0,
  totalItems: 0,
  error: false,
  success: false,
};

type CompaniesActions = ActionsOf<typeof companiesActions>;

export const companiesEntityReducer = produce((draft: CompaniesData, action: CompaniesActions) => {
  switch (action.type) {
    case getType(companiesActions.getCompanies.success): {
      const { result } = action.payload as { result: CompaniesData };

      draft.items = result.items;
      draft.pageNumber = result.pageNumber;
      draft.totalItems = result.totalItems;
      draft.loading = false;
      draft.error = false;

      return;
    }

    case getType(companiesActions.getCompanies.request): {
      draft.loading = true;
      draft.success = false;
      draft.error = false;

      return;
    }

    case getType(companiesActions.getCompanies.error): {
      draft.loading = false;
      draft.error = true;

      return;
    }

    case getType(companiesActions.editCompany.request): {
      draft.saving = true;
      draft.error = false;
      draft.success = false;

      return;
    }

    case getType(companiesActions.editCompany.error): {
      const payload = action.payload as { error?: ApiError };

      if (payload.error) {
        const errorMessage = JSON.parse(payload.error.message);
        draft.error = errorMessage[0];
      } else {
        draft.error = true;
      }

      draft.saving = false;

      return;
    }

    case getType(companiesActions.editCompany.success): {
      const { result } = action.payload as { result: Company };
      const index = draft.items.findIndex((company) => company.id === result.id);

      if (index !== -1) {
        draft.items[index] = { ...draft.items[index], ...result };
      }

      draft.error = false;
      draft.saving = false;
      draft.success = true;

      return;
    }

    case getType(companiesActions.addCompany.request): {
      draft.saving = true;
      draft.error = false;
      draft.success = false;

      return;
    }

    case getType(companiesActions.addCompany.error): {
      const payload = action.payload as { error?: ApiError };

      if (payload?.error?.message) {
        const errorMessage = JSON.parse(payload.error.message);
        draft.error = errorMessage[0];
      } else {
        draft.error = true;
      }

      draft.saving = false;
      draft.success = false;

      return;
    }

    case getType(companiesActions.addCompany.success): {
      draft.saving = false;
      draft.success = true;
      draft.error = false;

      return;
    }

    default:
      return;
  }
}, initialState);
